import { post } from '@/utils/request';

export const commonDelete = (params) => {
  return post('/api/v1/delete', params);
};
